import RowLoader from 'components/Sceletons/RowLoader';
import { IRestrictedUser } from 'interfaces';
import { useTranslation } from 'react-i18next';
import { useAppSelector } from 'store/hook';
import ContactsCard from './ContactsCard';
import classes from './ContactsTab.module.scss';
import React, { ChangeEvent } from 'react';
import ContactsDetails from './ContactsDetails';
import { Input } from 'antd';
import Assets from 'assets/icons';
import Mark from 'mark.js';

type Props = {
  clearRedux: () => void;
};

function ContactsTab({ clearRedux }: Props) {
  const [selectedContact, setSelectedContact] = React.useState<IRestrictedUser | null>(null);
  const [searchValue, setSearchValue] = React.useState('');

  const { globalUsers, isGroupLoading } = useAppSelector((state) => state.dataUsers);
  const { t } = useTranslation();

  const markText = (text: string, markerRef: React.RefObject<HTMLDivElement>, timeout?: number ) => {    
    const markInstance = new Mark(markerRef.current as HTMLElement);
    
    setTimeout(() => {
      markInstance.unmark({
        className: classes.mark,
        done: () => {
          markInstance.mark(text, {
            className: classes.mark,
          });
        }
      });
    }, timeout || 100);
  };

  const onItemClick = (user: IRestrictedUser | null) => setSelectedContact(user);
  const onSearch = (event: ChangeEvent<HTMLInputElement>) => {
    setSearchValue(event.target.value);
  };

  const searchedGlobalUsers = React.useMemo(
    () => globalUsers?.filter((user) =>
      `${user.first_name} ${user.last_name}`.toLowerCase().includes(searchValue.toLocaleLowerCase())
      || user.email.toLowerCase().includes(searchValue.toLocaleLowerCase())
    ),
    [searchValue, globalUsers]
  );  

  return (
    <div className={classes.usersTab}>
      
      {Boolean(selectedContact)
        ? (
          <ContactsDetails
            clearRedux={clearRedux}
            setSelectedContact={setSelectedContact}
            selectedContact={selectedContact!}
          />
        ) : (<>
          <Input
            suffix={<Assets.SearchIcon className={classes.searchIcon} />}
            type='search'
            allowClear
            className={classes.usersTabSearch}
            placeholder={t('Rooms.searchContact')}
            value={searchValue}
            onChange={onSearch}
          />
          
          <div className={classes.usersWrap}>
            {isGroupLoading ? (
              <div style={{ marginRight: 10 }}>
                <RowLoader width={600} padding={'0 0 0 0'} height={70} />
                <RowLoader width={600} marginTop={10} padding={'0 0 0 0'} height={70} />
                <RowLoader width={600} marginTop={10} padding={'0 0 0 0'} height={70} />
              </div>
            ) : searchedGlobalUsers[0] && !Boolean(selectedContact) ? <div>{
                searchedGlobalUsers.map((user) => (
                  <div key={user.id}>
                    <ContactsCard
                      onItemClick={onItemClick}
                      user={user}
                      markText={markText}
                      searchValue={searchValue}
                    />
                  </div>
                ))
              }</div> : <div className={classes.noFound}>{t('Users.Tabs.noFound')}</div>}

          </div>
        </>)
      }
      
    </div>
  );
}

export default ContactsTab;
